import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
import CustomImage from '../../../UIComponents/CustomImage';
import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';

export default function Form({ is_edit, edit_id, Page = "" }) {
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const InitialData = {
        role: "",
        designation: "",
        name: "",
        email: "",
        contact_number: ""
    }

    const [FormData, setFormData] = useState(InitialData);
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);

    const fetchSingleData = async (edit_id) => {
        const filter = { org_id: store_data?.org_id, id: edit_id }
        const response = await postAPI("/users/fetchSingle", {...filter, user: store_data});
        const UsersData = response?.data?.length > 0 ? response?.data[0] : {};
        if (response?.status == 1) {
            setFormData({
                id: UsersData["id"],
                role: UsersData["role"],
                name: UsersData["name"],
                email: UsersData["email"],
                designation: UsersData["designation"],
                contact_number: UsersData["contact_number"],
            });
            setLoading(false)
        } else {
            setFormData({});
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
                setCanEdit(true);
            } else {
                const createAllowed = await hasPermission("GENERAL", "Users", "CREATE");
                const editAllowed = await hasPermission("GENERAL", "Users", "EDIT");
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
            }
        };
        checkPermissions();

        setLoading(false)
        if(is_edit)
            fetchSingleData(edit_id)
    }, [is_edit, edit_id])


    const validate = () => {
        let errors = [];
        if (!FormData.role) errors.push('Role is required.');
        if (!FormData.designation) errors.push('Designation is required.');
        if (!FormData.name) errors.push('Name is required.');
        if (!FormData.email) errors.push('Username (email) is required.');
        else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(FormData.email)) errors.push('Invalid email format.');
        if (!FormData.contact_number) errors.push('Contact Number is required.');
        else if (!/^\d{10,15}$/.test(FormData.contact_number)) errors.push('Contact Number must be 10-15 digits.');
        setError(errors);
        return errors.length === 0;
    };

    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) return;
        
        if (!isAdmin() && ((is_edit && !canEdit) || (!is_edit && !canCreate))) {
            toast.error('You do not have permission to perform this action.');
            setIsBTNClicked(false);
            return;
        }
        
        if (!validate()) {
            setIsBTNClicked(false);
            toast.error('Please fix validation errors.');
            return;
        }
        setIsBTNClicked(true);
        const payload = { org_id: store_data?.org_id, ...FormData };
        const response = await postAPI(is_edit ? "/users/update-info" : "/users/registration-by-verification-link", {...payload, user: store_data});
        if (response?.status == 1) {
            setIsBTNClicked(false);
            toast.success('New User Added Successfully.');
            window.location.reload();
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }
    return (
        <>
            {Loading ? <Loader /> :
                (!isAdmin() && !canCreate && !canEdit) ? (
                    <div className="alert alert-danger">You do not have permission to access this form.</div>
                ) : (
                    <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                        <div className="col-12 col-md-6 mt-0">
                            <SelectBoxHandler form_data={FormData} setFormData={setFormData} Name="role" Label="Role" Options={[{ value: 'ADMIN', label: 'Admin' }, { value: 'EMPLOYEE', label: 'Employee' }]} Placeholder="Select Role" is_disabled={is_edit ? true : false} />
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="designation" Type="text" Label="Designation" />
                        </div>
                        <div className="col-12 col-md-12 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="name" Type="text" Label="Name" />
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="email" Type="text" Label="Username" is_disabled={is_edit ? true : false} />
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="contact_number" Type="text" Label="Contact Number" />
                        </div>
                        {Error.length > 0 && (
                            <div className="alert alert-danger">
                                <ul>{Error.map((e, i) => <li key={i}>{e}</li>)}</ul>
                            </div>
                        )}
                    </FormSubmissionHandler>
                )
            }
            <ToastContainer  position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
